import {useMemo, useReducer} from "react";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Context from "app/context";
import useScrollbarWidth from "lib/hooks/use-scrollbar-width";

export default function setup({createInitialState, createRoutes, Reducer}) {
  return (props) => {
    const [reducer, dispatch] = useReducer(Reducer, props, createInitialState);
    const state = useMemo(() => ({...reducer, dispatch}), [reducer, dispatch]);
    const router = useMemo(() => createBrowserRouter(createRoutes(state)), []);

    useScrollbarWidth();

    return (
      <Context.Provider value={state}>
        <RouterProvider router={router} />
      </Context.Provider>
    );
  };
}
